<template>
  <div class="loto">
    <Banner :class-banner="'banner-loto'" />
    <SectionPickTabs />
    <Information />
  </div>
</template>

<script>
import Banner from '@/components/common/banner';
import SectionPickTabs from '@/views/web/loto/section-pick-tabs/index';
import Information from '@/views/web/loto/information';
export default {
  components: {
    Banner,
    SectionPickTabs,
    Information
  }
}
</script>
